export const cleanUrl = (documentUrl) => {
    let url = documentUrl;
    const allowedHosts = [
        'automotive-api.s3.us-east-2.amazonaws.com',
        'https://api.twilio.com',
    ];

    const isAllowed = allowedHosts.some((host) => url.includes(host));
    if (isAllowed) return url;

    return `https://automotive-api.s3.us-east-2.amazonaws.com/${url}`;
};
